// removed by extract-text-webpack-plugin
module.exports = {"buttonStyles":"buttonStyles___3PL6H","divStyles":"divStyles___2nuAC","subtitleStyles":"subtitleStyles___2BBIC","leftGrid":"leftGrid___1xp7l","titleStyles":"titleStyles___3Ib3J","centerContent":"centerContent___11dkj"};


//////////////////
// WEBPACK FOOTER
// ./src/vp-ui/components/VpDialogTitle.module.less
// module id = 3160
// module chunks = 33